import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NocDashboardComponent } from '../noc-dashboard/noc-dashboard.component';
import { AdminstrationComponent } from '../adminstration/adminstration.component';
import { RoleComponent } from '../adminstration/role/role.component';
import { UserComponent } from '../adminstration/user/user.component';
import { DataAssignmentComponent } from '../adminstration/data-assignment/data-assignment.component';
import { WorkFlowComponent } from '../adminstration/work-flow/work-flow.component';
import { SettingComponent } from '../setting/setting.component';
import { CodeValueComponent } from '../setting/code-value/code-value.component';
import { FieldComponent } from '../setting/field/field.component';
import { HierachyComponent } from '../setting/hierachy/hierachy.component';
import { NocListComponent } from '../noc-list/noc-list.component';
import { AfterDepartmentComponent } from '../after-department/after-department.component';
import { AccountantComponent } from '../accountant/accountant.component';
import { CartoScreenComponent } from '../carto-screen/carto-screen.component';
// import { CartoScreeComponent } from 'src/app/carto-scree/carto-scree.component';
const routes: Routes = [
  {
    path: "NOC-index",
    component: NocDashboardComponent,
    //canActivate: [RoleGuardService], data: { ComponentCode: 'EMD-R1' }
  },

  {
    path: "noc-list",
    component: NocListComponent,
    //canActivate: [RoleGuardService], data: { ComponentCode: 'EMD-R1' }
  },
  {
    path: "noc-carto",
    component:CartoScreenComponent,
    //canActivate: [RoleGuardService], data: { ComponentCode: 'EMD-R1' }
  },

  {
    path: "after-department",
    component: AfterDepartmentComponent,
    //canActivate: [RoleGuardService], data: { ComponentCode: 'EMD-R1' }
  },
  {
    path: "accountant",
    component: AccountantComponent,
    //canActivate: [RoleGuardService], data: { ComponentCode: 'EMD-R1' }
  },


  {
    "path": "administration",
    "component": AdminstrationComponent,
    "children": [


      {
        path: "roles",
        component: RoleComponent,
        // canActivate: [RoleGuardService], data: { ComponentCode: 'USTP-R7' }
      },
      {
        path: "users",
        component: UserComponent,
        // canActivate: [RoleGuardService], data: { ComponentCode: 'USTP-R8' }
      },

      {
        path: "data-assignment",
        component: DataAssignmentComponent
        //  canActivate: [RoleGuardService], data: { ComponentCode: 'USTP-R9' }
      },

      {
        path: "workflow",
        component: WorkFlowComponent
        // canActivate: [RoleGuardService], data: { ComponentCode: 'USTP-R10' }
      },

    ]
  },

  {

    "path": "noc-setting",
    "component": SettingComponent,
    "children": [
      {
        path: "code-value",
        component: CodeValueComponent,
        // canActivate: [RoleGuardService], data: { ComponentCode: 'USTP-R12' }
      },
      {
        path: "field",
        component: FieldComponent,
        //  canActivate: [RoleGuardService], data: { ComponentCode: 'USTP-R11' }
      },

      {
        path: "hierachy",
        component: HierachyComponent,
        //  canActivate: [RoleGuardService], data: { ComponentCode: 'USTP-R14' }

      }

    ]

  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NocLayoutRoutingModule { }
